import { useNavigate } from 'react-router-dom'
import MobileLayout from '../../components/MobileLayout'
import { Scale, Image } from 'lucide-react'

export default function MobileBvp() {
  const navigate = useNavigate()

  return (
    <MobileLayout>
      <div className="p-4 space-y-4">
        <div className="bg-white rounded-2xl shadow-sm p-4 mb-2">
          <h1 className="font-bold text-gray-900 text-lg">BVP</h1>
          <p className="text-sm text-gray-500 mt-0.5">Contrôle des poids & étiquettes cartons</p>
        </div>

        <button onClick={() => navigate('/app/bvp/control')}
          className="w-full bg-white rounded-2xl shadow-sm border border-gray-100 p-6 flex items-center gap-5 text-left hover:border-blue-300 transition-colors active:opacity-70">
          <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center flex-shrink-0">
            <Scale size={32} className="text-blue-600" />
          </div>
          <div>
            <p className="font-bold text-gray-900 text-lg">Contrôle des poids</p>
            <p className="text-sm text-gray-500 mt-1">Saisir un contrôle BVP</p>
          </div>
        </button>

        <button onClick={() => navigate('/app/bvp/photos')}
          className="w-full bg-white rounded-2xl shadow-sm border border-gray-100 p-6 flex items-center gap-5 text-left hover:border-blue-300 transition-colors active:opacity-70">
          <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center flex-shrink-0">
            <Image size={32} className="text-green-600" />
          </div>
          <div>
            <p className="font-bold text-gray-900 text-lg">Étiquettes cartons</p>
            <p className="text-sm text-gray-500 mt-1">Prendre et consulter les photos</p>
          </div>
        </button>
      </div>
    </MobileLayout>
  )
}
